<template>
  <div class="main-page container">
    <h2 :class="['title-26-600', { 'de-title': locale === 'de' || locale === 'pt-br' || locale === 'it' }]" v-html="$t('start_metasafe_v2_title')" />
    <LoadingProgress class="main-page__progress" />
    <AgeForm />
    <div class="footer">
      <p class="footer-info" v-html="$t('start_v6_legal_footer')" />
      <span v-html="$t('start_v6_company_details')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingProgress from '@/components/homePage/LoadingProgress.vue';
import AgeForm from '@/components/homePage/AgeForm.vue';

const { locale } = useI18n();
</script>

<style lang="scss" scoped>
.main-page {
  font-family: $primary-fonts;
  width: 100%;

  &__progress {
    height: 20px;
  }

  .title-26-600 {
    font-size: 20px;
    text-align: left;
    font-weight: 700;
    color: $text-color;
    white-space: nowrap;

    @media (min-width: 400px ) {
      text-align: center;
      font-size: 21px;
    }
  }

  .de-title {
    white-space: break-spaces;
    text-align: center;
  }

  .footer {
    font-family: $primary-fonts;
    padding: 48px 0;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */

    &:deep(.footer-info) {
      color: $text-color;
      margin-bottom: 64px;
      opacity: .75;
      letter-spacing: -0.1px;
      a {
        color: $text-link;
        text-decoration: underline;
      }
    }

    span {
      display: block;
      color: $text-color;
      opacity: .25;
      line-height: 1.5;
    }
  }
}
</style>
